<template>
  <List :mapState="'academicAttendant'" :showbtn="false" :allDispatch="'academicAttendantAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/attendant/list.vue